import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { v4 as uuidv4 } from 'uuid';
import { lookupsJson } from '@ourbranch/lookups';
import { Formik, Form } from 'formik';
import classNames from 'classnames';

import { FormField, FormSubmit } from 'core/components/form';
import { validationSchema } from './add-farm-interested-party.validation';
import useStyles from '../../people/add-form.styles';

const FormContent = ({ disabled, classes, associatedEntityOptions }) => {
  return (
    <Form disabled={disabled} className={classes.container} id="addInterestedParty">
      <Grid
        key="container"
        container
        justifyContent="space-around"
        alignItems="flex-start"
        className={classes.formContainer}
        spacing={4}
      >
        <FormField
          mode="light"
          name="relationship"
          id="relationship"
          label="Relationship"
          type="select"
          options={lookupsJson.farm.farmInterestedPartyTypes}
          xs={6}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="name"
          id="name"
          label="Name or Company"
          type="string"
          xs={6}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="address"
          id="address"
          label="Address"
          type="address"
          xs={8}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="address2"
          id="address2"
          label="Address 2"
          type="string"
          optional
          xs={4}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="city"
          id="city"
          label="City"
          type="string"
          optional
          xs={4}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="state"
          id="state"
          label="State"
          type="state"
          optional
          xs={4}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="zip"
          id="zip"
          label="Zip code"
          type="string"
          optional
          xs={4}
          permissions={{ isLicensedAction: false }}
        />
        <FormField
          mode="light"
          name="email"
          id="email"
          label="Email"
          type="string"
          placeholder="contact@example.com"
          xs={12}
          permissions={{ isLicensedAction: false }}
        />
      </Grid>
      <Grid container justifyContent="flex-end" alignItems="center" spacing={4}>
        <FormField
          mode="light"
          name="associatedEntities"
          id="associatedEntities"
          label="Select associated entity (optional)"
          type="select"
          options={associatedEntityOptions}
          xs={8}
          permissions={{ isLicensedAction: false }}
        />
        <FormSubmit
          mode="big"
          className={classNames(classes.button, classes.addButton)}
          variant="contained"
          color="secondary"
          xs={4}
        >
          Add Farm Interested Party
        </FormSubmit>
      </Grid>
    </Form>
  );
};

function AddFarmInterestedPartyForm({ onAdd, disabled, associatedEntityOptions }) {
  const classes = useStyles();

  return (
    <Formik
      initialValues={{
        id: uuidv4(),
        name: undefined,
        email: undefined,
        address: undefined,
        relationship: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        zip: undefined,
        associatedEntities: undefined
      }}
      validationSchema={validationSchema}
      onSubmit={({ id, name, email, relationship, address, address2, city, state, zip, associatedEntities }) =>
        onAdd({
          id,
          name,
          email,
          relationship,
          address: { address, address2, city, state, zip },
          associatedEntities: [associatedEntities],
          lossPayee: false
        })
      }
    >
      {() => <FormContent disabled={disabled} classes={classes} associatedEntityOptions={associatedEntityOptions} />}
    </Formik>
  );
}

FormContent.propTypes = {
  disabled: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  associatedEntityOptions: PropTypes.array
};

FormContent.defaultProps = {
  disabled: false,
  associatedEntityOptions: []
};

AddFarmInterestedPartyForm.propTypes = {
  onAdd: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  associatedEntityOptions: PropTypes.array
};
AddFarmInterestedPartyForm.defaultProps = {
  disabled: false,
  associatedEntityOptions: []
};

export default AddFarmInterestedPartyForm;
